import HttpClient from "libs/utils/HttpClient";
import qs from "qs";
class DashboardService {
  async getDashboardLayout() {
    try {
      const response = await HttpClient.get(`/api/dashboard/layout`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getReportDashboard(body) {
    const params = qs.stringify({
      ...(body.endDate && { endDate: body.endDate }),
    });

    try {
      const response = await HttpClient.getBlob(
        `/api/report/dashboard?${params}`
      );

      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async updateDashboardLayout(body) {
    try {
      const response = await HttpClient.post(
        `/api/dashboard/layout/update`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getDashboardData(body) {
    try {
      const response = await HttpClient.post(`/api/dashboard/data`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new DashboardService();
